const TABLET_MAX_WIDTH = 1024
const MOBILE_MAX_WIDTH = 414

const getScreenSize = () => typeof window !== 'undefined' && window ? window.innerWidth : 0 

export const isMobile = () => {
  return getScreenSize() <= MOBILE_MAX_WIDTH
}

export const isTablet = () => {  
  return getScreenSize() > MOBILE_MAX_WIDTH && getScreenSize() <= TABLET_MAX_WIDTH 
}

export const isDesktop = () => {  
  return getScreenSize() > TABLET_MAX_WIDTH 
}

export const delay = (func: any, delay: number = 0): void => {
  setTimeout(() => {
    func()
  }, delay)
}